module.exports = __webpack_public_path__ + "static/media/01-explore-walkthrough.e75ac080.svg";